import { FC } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import { cx } from "class-variance-authority";
import { ChevronDown, ChevronUp } from "lucide-react";
import classes from "./select.module.css";

export interface SelectOption {
  label: string;
  value: string;
}

interface SelectProps {
  label: string;
  options: SelectOption[];
  value?: string;
  defaultValue?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  triggerClassName?: string;
}

const Select: FC<SelectProps> = ({
  label,
  options,
  value,
  defaultValue,
  onValueChange,
  placeholder = "Pasirinkite...",
  disabled,
  className,
  labelClassName,
  triggerClassName,
}) => {
  return (
    <div className={cx(classes.inputGroup, className)}>
      <span className={cx(labelClassName)}>{label}</span>
      <SelectPrimitive.Root
        value={value}
        defaultValue={defaultValue}
        onValueChange={onValueChange}
        disabled={disabled}
      >
        <SelectPrimitive.Trigger
          className={cx(classes.trigger, triggerClassName)}
        >
          <SelectPrimitive.Value placeholder={placeholder} />
          <SelectPrimitive.Icon className={classes.chevron}>
            <ChevronDown size={20} />
          </SelectPrimitive.Icon>
        </SelectPrimitive.Trigger>

        <SelectPrimitive.Portal>
          <SelectPrimitive.Content
            className={classes.content}
            position="popper"
            sideOffset={5}
          >
            <SelectPrimitive.ScrollUpButton className={classes.scrollButton}>
              <ChevronUp size={20} />
            </SelectPrimitive.ScrollUpButton>
            <SelectPrimitive.Viewport className={classes.viewport}>
              {options.map((option) => (
                <SelectPrimitive.Item
                  key={option.value}
                  value={option.value}
                  className={classes.item}
                >
                  <SelectPrimitive.ItemText>
                    {option.label}
                  </SelectPrimitive.ItemText>
                </SelectPrimitive.Item>
              ))}
            </SelectPrimitive.Viewport>
            <SelectPrimitive.ScrollDownButton className={classes.scrollButton}>
              <ChevronDown size={20} />
            </SelectPrimitive.ScrollDownButton>
          </SelectPrimitive.Content>
        </SelectPrimitive.Portal>
      </SelectPrimitive.Root>
    </div>
  );
};

export default Select;
